import React, { useEffect, useState } from "react";
import { fbUpdateGroup } from "../../../../services/firebaseService/endPoints/group";
import { fbGetGroupSettings } from "../../../../services/firebaseService/endPoints/admin/groupConfig";
import FUpload from "../../../commons/formFields/FUpload";
import useAdminDataStore, { selectCurrentGroupData } from "../../../../store/adminData/adminData";
import { doc, getDoc } from "firebase/firestore";
import { ChantSelect } from "../../../../CommonComponents";
import { toast } from "react-toastify";
import {
  invalidateStadiumCache,
  postUpdateCDNUtil,
  rgbToHex,
} from "../../../../helperFunctions/util";
import ChantButton from "../../../../CommonComponents/ChantButton/ChantButton";
import { db } from "../../../../services/firebaseService/connection";
import "./GroupDesign.css";
import AppIconModal from "./AppIconModal";

import AppIcon1 from "../../../../images/app-icons/1.png";
import AppIcon2 from "../../../../images/app-icons/2.png";
import AppIcon3 from "../../../../images/app-icons/3.png";
import AppIcon4 from "../../../../images/app-icons/4.png";
import AppIcon5 from "../../../../images/app-icons/5.png";
import AppIcon6 from "../../../../images/app-icons/6.png";
import AppIcon7 from "../../../../images/app-icons/7.png";
import AppIcon8 from "../../../../images/app-icons/8.png";
import AppIcon9 from "../../../../images/app-icons/9.png";
import AppIcon10 from "../../../../images/app-icons/10.png";
import AppIcon11 from "../../../../images/app-icons/11.png";
import AppIcon12 from "../../../../images/app-icons/12.png";
import AppIcon13 from "../../../../images/app-icons/13.png";
import AppIcon14 from "../../../../images/app-icons/14.png";
import AppIcon15 from "../../../../images/app-icons/15.png";
import AppIcon16 from "../../../../images/app-icons/16.png";
import AppIcon17 from "../../../../images/app-icons/17.png";
import AppIcon18 from "../../../../images/app-icons/18.png";
import AppIcon19 from "../../../../images/app-icons/19.png";
import AppIcon20 from "../../../../images/app-icons/20.png";
import ScreenHeader from "../../../../CommonComponents/ScreenHeader/ScreenHeader.jsx";
import DescriptionText from "../../../../CommonComponents/DescriptionText/DescriptionText.jsx";
import AppColorPreview from "./AppColorPreview/AppColorPreview.jsx";
import { hexToRgbaObject } from "../../../../utils/colors.js";
import logger from "../../../../utils/logger.js";
import { refreshGroupData } from "../../../../redux/actions/adminData.js";

const appIcons = [
  AppIcon1,
  AppIcon2,
  AppIcon3,
  AppIcon4,
  AppIcon5,
  AppIcon6,
  AppIcon7,
  AppIcon8,
  AppIcon9,
  AppIcon10,
  AppIcon11,
  AppIcon12,
  AppIcon13,
  AppIcon14,
  AppIcon15,
  AppIcon16,
  AppIcon17,
  AppIcon18,
  AppIcon19,
  AppIcon20,
];

const GroupDesign = () => {
  const [logoList, setLogoList] = useState([]);
  const [transparentLogoList, setTransparentLogoList] = useState([]);

  const groupData = useAdminDataStore(selectCurrentGroupData);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);

  const [primaryColor, setPrimaryColor] = useState({
    r: "",
    g: "",
    b: "",
    a: "",
  });
  const [secondaryColor, setSecondaryColor] = useState({
    r: "",
    g: "",
    b: "",
    a: "",
  });

  const [imageChanged, setImageChanged] = useState(false);
  const [updated, setUpdated] = useState(true);
  const [logoFile, setLogoFile] = useState({});
  const [transparentLogoFile, setTransparentLogoFile] = useState({});
  const [preview, setPreview] = useState("");
  const [showIconModal, setShowIconModal] = useState(false);
  const [colors, setColors] = useState([
    "#000000",
    "#B80000",
    "#DB3E00",
    "#FCCB00",
    "#008B02",
    "#006B76",
    "#1273DE",
    "#004DCF",
  ]);

  const [selectedAppIconIndex, setSelectedAppIconIndex] = useState(6);

  const handleColorChange = (color, type) => {
    if (type === "primaryColor") {
      setPrimaryColor(hexToRgbaObject(color));
    }
    if (type === "secondaryColor") {
      setSecondaryColor(hexToRgbaObject(color));
    }
    setUpdated(false);
  };

  const uploadAction = (file) => {
    if (logoImgType === "regular") {
      setLogoFile(file);
    } else {
      setTransparentLogoFile(file);
    }
    setUpdated(false);
  };

  const handleImageChange = ({ fileList }) => {
    if (fileList.length === 0) {
      setPreview("");
    }
    if (logoImgType === "regular") {
      if (fileList.length === 0) {
        setLogoFile({});
      } else {
        setLogoFile(fileList[0].originFileObj);
      }

      setLogoList(fileList);
    } else {
      if (fileList.length === 0) {
        setTransparentLogoFile({});
      } else {
        setTransparentLogoFile(fileList[0].originFileObj);
      }

      setTransparentLogoList(fileList);
    }

    setImageChanged(true);
    setUpdated(false);
  };

  const handleConfigurationUpdate = async (e) => {
    try {
      e.preventDefault();

      if (submitLoading || fetchLoading) {
        return;
      }

      setSubmitLoading(true);

      const finalLogo =
        logoImgType === "transparent" ? transparentLogoFile : logoFile;

      if (imageChanged && !finalLogo?.name) {
        toast.error("Group Logo is required");
        setSubmitLoading(false);
        return;
      } else {
        let data = {
          configuration: {
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            appIcon: String(selectedAppIconIndex + 1),
            isLogoTransparent: logoImgType === "transparent",
          },
        };

        await fbUpdateGroup(
          data,
          groupData?.id,
          imageChanged && finalLogo,
        ).then(() => {
          postUpdateCDNUtil(groupData?.id);
          invalidateStadiumCache(groupData?.groupKey);
          // getGroupSettings(true);
          refreshGroupData(groupData?.id);
        });
      }
    } catch (error) {
      logger.error("Error updating group configuration");
    } finally {
      setSubmitLoading(false);
    }
  };

  const getGroupSettings = async (updated = false) => {
    try {
      setFetchLoading(true);
      const configuration = await fbGetGroupSettings(groupData?.id);
      let logoList = [];
      let transparentLogoList = [];

      const { logo, isLogoTransparent } = configuration;

      if (logo && isLogoTransparent) {
        transparentLogoList = [{ uid: "-1", url: configuration?.logo }];
      } else {
        logoList = [{ uid: "-1", url: configuration?.logo }];
      }

      setUpdated(updated);
      setPrimaryColor(configuration?.primaryColor);
      setSecondaryColor(configuration?.secondaryColor);
      setLogoList(logoList);
      setTransparentLogoList(transparentLogoList);
      setLogoImgType(
        configuration?.isLogoTransparent ? "transparent" : "regular",
      );
      setSelectedAppIconIndex(Number(configuration?.appIcon || "7") - 1);

      const docSnapshot = await getDoc(
        doc(db, "clubColors", groupData?.clubId),
      );
      if (docSnapshot?.exists()) {
        let data = docSnapshot?.data() || {};
        let colors = [];
        Object.keys(data).forEach((key) => {
          if (
            key.includes("color") &&
            data[key].r !== "" &&
            data[key].g !== "" &&
            data[key].b !== ""
          ) {
            let color = data[key];
            Object.keys(color).forEach((key) => {
              if (typeof color[key] === "string") {
                color[key] = parseInt(color[key]);
              }
            });
            let hexColor = rgbToHex(color.r, color.g, color.b);
            colors.push(hexColor);
          }
        });
        colors = Array.from(new Set([...colors, "#ffffff", "#000000"]));
        setColors(colors);
      }
    } catch (error) {
      logger.error("Error fetching group settings");
    } finally {
      setFetchLoading(false);
    }
  };

  const handleSelectIcon = (iconId) => {
    setSelectedAppIconIndex(iconId);
    setUpdated(false);
  };

  useEffect(() => {
    getGroupSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupData.id]);

  const [logoImgType, setLogoImgType] = useState("regular");

  const handleImageTypeChange = (val) => {
    setPreview("");
    setLogoImgType(val);
  };

  return (
    <div className="group-design-container">
      <ScreenHeader title="Design" />

      <div style={{ marginTop: "var(--screen-general-margin)" }}>
        <DescriptionText showBackground={true}>
          Upload your group logo and select colors for the app icon, app splash
          screen and app header / website.
        </DescriptionText>
      </div>

      <form className="group-design-form" onSubmit={handleConfigurationUpdate}>
        {/* Group Name */}
        <div className="group-design-section">
          <div>
            <p className="group-design-section__title">Group Name</p>
            <p className="group-design-section__desc">
              Request group name changes via support@chant.fan.
            </p>
          </div>
          <div className="group-design-section__content">
            <p style={{ fontWeight: "bold", fontSize: "1rem", margin: 0 }}>
              {groupData.groupName}
            </p>
          </div>
        </div>

        {/* Group Logo */}
        <div className="group-design-section">
          <div>
            <p className="group-design-section__title">Group Logo</p>
            <p className="group-design-section__desc">
              Upload your group logo to be used across the app, website, and
              directory.
            </p>
          </div>
          <div className="group-design-section__content">
            <div>
              <p style={{ fontWeight: "bold", marginBottom: 4 }}>Image Type:</p>
              <ChantSelect
                popupMatchSelectWidth={false}
                options={[
                  { value: "regular", label: "Regular (JPG)" },
                  { value: "transparent", label: "Transparent (PNG)" },
                ]}
                value={logoImgType}
                onChange={handleImageTypeChange}
              />
            </div>
            <FUpload
              aspectRatio={1 / 1}
              showCropOptions={logoImgType === "regular"}
              action={uploadAction}
              isAvatar={logoImgType === "regular"}
              accept={logoImgType === "regular" ? ".jpg,.jpeg,.png" : ".png"}
              fileList={
                logoImgType === "regular" ? logoList : transparentLogoList
              }
              onChange={handleImageChange}
              onLoad={(preview) => {
                setPreview(preview);
              }}
            />
          </div>
        </div>

        {/* App Icon */}
        <div className="group-design-section">
          <div>
            <p className="group-design-section__title">App Icon</p>
            <p className="group-design-section__desc">
              Members for both iOS and Android can now select their own personal
              app icon color. We have removed this as a global setting for
              admin.
            </p>
            <ChantButton
              type="primary"
              onClick={() => setShowIconModal((prev) => !prev)}
            >
              See Examples
            </ChantButton>
          </div>
          <div className="group-design-section__content">
            <img
              alt="app-icon"
              height={100}
              width={100}
              src={appIcons[selectedAppIconIndex]}
            />
          </div>
        </div>

        {/* Colors & App Preview */}
        <div
          className="group-design-section"
          style={{ display: "flex", flexDirection: "column", gap: "16px" }}
        >
          <div>
            <p className="group-design-section__title">Group Colors</p>
            <p className="group-design-section__desc">
              Select from the preset colors (Chant can add upon request) or
              manually enter color values.
            </p>
          </div>
          <AppColorPreview
            handleColorChange={handleColorChange}
            colors={colors}
            isLogoTransparent={logoImgType === "transparent"}
            logoImage={
              logoImgType === "regular" ? logoList : transparentLogoList
            }
            preview={preview}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            groupName={groupData?.groupName}
          />
        </div>

        <div className="group-design-footer">
          <ChantButton
            htmlType="submit"
            disabled={updated || fetchLoading || submitLoading}
            loading={submitLoading}
          >
            {updated ? "Updated" : "Update changes"}
          </ChantButton>
        </div>
      </form>

      <AppIconModal
        showIconModal={showIconModal}
        handleModalOpen={(val) => setShowIconModal(val)}
        handleSelectIcon={handleSelectIcon}
        selectedAppIconIndex={selectedAppIconIndex}
      />
    </div>
  );
};

export default GroupDesign;
